// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3SvVx","upload":"Small_upload__Cm_kx","imageWrap":"Small_imageWrap__3Hsbz","removeBtn":"Small_removeBtn__1UEAY"};